<template>
  <div class="container">
    <div class="row">
      <form id="searchUsers" @submit.prevent="submit">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <label for="email" class="form-label">E-mail</label>
          <input v-model="searchForm.email" class="form-control" placeholder="E-mail address" type="text"/>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <input type="submit" class="btn btn-success" value="Search"/>
        </div>
      </form>
    </div>
    <br/>
    <div class="row">
      <h4>Search results</h4>
      <table class="table">
        <thead>
        <th scope="col">More:</th>
        <th scope="col">First name</th>
        <th scope="col">Last name</th>
        <th scope="col">E-mail address</th>
        <th scope="col">Created at</th>
        <th scope="col">Updated at</th>
        </thead>
        <tbody>
        <tr v-for="row in users" :key="row.id">
          <td><a :href="'/admin/users/' + row.id" target="_blank">More details</a></td>
          <td>{{ row.firstname }}</td>
          <td>{{ row.lastname }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.createdAt }}</td>
          <td>{{ row.updatedAt }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

export default {
  name: 'UserSearch',
  el: '#searchUsers',
  setup() {

  },
  data() {
    return {
      searchForm: {
        email: ''
      },
      users: []
    }
  },
  methods: {
    submit: async function () {
      const results = await apiClient(`users/?filter={"where":{"email":"${this.searchForm.email}"}}`, HTTP_METHODS.GET);
      if (results.status === HTTP_STATUS_CODES.SUCCESS) {
        this.users = results.data
      }
    }
  }
}
</script>
